import { IPropertyBuildingUnitForm } from "@rf/property/module/components/property-form/util/schemas/building-form/building-unit.schema";
import { IModalSchema } from "../BuildingUnitFormModal";

export const convertUnitStateToSchema = (
  unitState: IPropertyBuildingUnitForm
): IModalSchema => {
  return {
    id: unitState.id,
    name: unitState.name,
    price: unitState.price,
    currency: unitState.currency,
    bedrooms: unitState.bedrooms ? [parseFloat(unitState.bedrooms)] : [],
    bathrooms: unitState.bathrooms ? [parseFloat(unitState.bathrooms)] : [],
    halfBathrooms: unitState.halfBathrooms
      ? [parseFloat(unitState.halfBathrooms)]
      : [],
    parkingSpots: unitState.parkingSpots ? [parseFloat(unitState.parkingSpots)] : [],
    levelFloor: unitState.levelFloor ? [parseFloat(unitState.levelFloor)] : [],
    totalFloor: unitState.totalFloor ? [parseFloat(unitState.totalFloor)] : [],
    metersConstruction: unitState.metersConstruction,
    metersLand: unitState.metersLand,
    isNew: unitState.isNew,
    isDelete: unitState.isDelete,
    maintenanceFee: unitState.maintenanceFee,
    maintenanceCurrency: unitState.maintenanceCurrency,
    features: unitState.features,
    totalCommission: unitState.totalCommission,
    commissionGuaranteed: unitState.commissionGuaranteed,
    characteristics_roof_property: unitState.characteristics_roof_property,
    characteristics_roof_form_property: unitState.characteristics_roof_form_property,
    characteristics_frames_property: unitState.characteristics_frames_property,
    characteristics_door_property: unitState.characteristics_door_property,
    characteristics_closets_property: unitState.characteristics_closets_property,
    characteristics_windows_property: unitState.characteristics_windows_property,
    characteristics_cabinets_property: unitState.characteristics_cabinets_property,
    characteristics_floors_property: unitState.characteristics_floors_property,
    characteristics_type_house_property:
      unitState.characteristics_type_house_property
  } as IModalSchema;
};

export const convertSchemaToUnitState = (
  schema: IModalSchema
): IPropertyBuildingUnitForm => {
  return {
    id: schema.id,
    name: schema.name,
    price: schema.price,
    currency: schema.currency,
    bedrooms: schema.bedrooms.length ? schema.bedrooms[0].toString() : "",
    bathrooms: schema.bathrooms.length ? schema.bathrooms[0].toString() : "",
    halfBathrooms: schema.halfBathrooms.length
      ? schema.halfBathrooms[0].toString()
      : "",
    parkingSpots: schema.parkingSpots.length
      ? schema.parkingSpots[0].toString()
      : "",
    levelFloor: schema.levelFloor.length ? schema.levelFloor[0].toString() : "",
    totalFloor: schema.totalFloor.length ? schema.totalFloor[0].toString() : "",
    metersConstruction: schema.metersConstruction,
    metersLand: schema.metersLand,
    isNew: schema.isNew,
    isDelete: schema.isDelete,
    maintenanceFee: schema.maintenanceFee,
    maintenanceCurrency: schema.maintenanceCurrency,
    features: schema.features,
    totalCommission: schema.totalCommission,
    commissionGuaranteed: schema.commissionGuaranteed,
    characteristics_roof_property: schema.characteristics_roof_property,
    characteristics_roof_form_property: schema.characteristics_roof_form_property,
    characteristics_frames_property: schema.characteristics_frames_property,
    characteristics_door_property: schema.characteristics_door_property,
    characteristics_closets_property: schema.characteristics_closets_property,
    characteristics_windows_property: schema.characteristics_windows_property,
    characteristics_cabinets_property: schema.characteristics_cabinets_property,
    characteristics_floors_property: schema.characteristics_floors_property,
    characteristics_type_house_property: schema.characteristics_type_house_property
  };
};
